import React from "react";
import { Link } from 'gatsby';
import PropTypes from "prop-types";
import requiredIf from "~utils/requiredIf";
import formatURL from "~utils/formatURL";

const NewsTile = (props) => {
    const { url, cmsImage, imgUrl, imgAlt, date, title } = props;

    return (
        <Link to={formatURL(url)} className="news-tile">
            <div className="news-image">
                {cmsImage && cmsImage}
                {(!cmsImage && imgUrl) && <img src={imgUrl} alt={imgAlt} />}
            </div>
            <div className="news-content">
                <span>{date}</span>
                <h4>{title}</h4>
            </div>
        </Link>
    );
};

export default NewsTile;

NewsTile.propTypes = {
    url: PropTypes.string.isRequired,
    cmsImage: PropTypes.object,
    imgUrl: requiredIf(PropTypes.string, (props) => !props.cmsImage),
    imgAlt: requiredIf(PropTypes.string, (props) => props.imgUrl),
    date: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};
